<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      modalConfirmar: state => state.modal.confirmar
    })
  },
  methods: {
    ...mapActions({
      okConfirmar: 'modal/okConfirmar',
      closeConfirmar: 'modal/closeConfirmar'
    })
  }
}
</script>

<template>
  <v-dialog v-model="modalConfirmar.estado" @input="v => v || closeConfirmar()" width="300">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Confirmar
      </v-card-title>
      <v-card-text>
        <div class="confirmar-text">
          {{ modalConfirmar.msg }}
        </div>
        <v-btn @click="okConfirmar" color="primary"> SIM </v-btn>
        <v-btn @click="closeConfirmar"> NÃO </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
